import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const AdminGuard = () => {
    const { session, userRole } = useAuth();

    if (!session) {
        return <Navigate to="/login" replace />;
    }

    // Jika bukan admin provinsi atau nasional, lempar ke dashboard member
    if (userRole !== 'admin_provinsi' && userRole !== 'admin_nasional') {
        return <Navigate to="/member" replace />;
    }

    return <Outlet />;
};

export const MemberGuard = () => {
    const { session, userRole } = useAuth();

    if (!session) {
        return <Navigate to="/login" replace />;
    }

    // Jika admin mencoba masuk rute pendaftar/member, lempar ke dashboard admin
    if (userRole === 'admin_provinsi' || userRole === 'admin_nasional') {
        return <Navigate to="/admin" replace />;
    }

    return <Outlet />;
};